import type { CSSProperties, FC } from "react";
import type {
    TotalsComponentColumns,
    TotalsComponentSettings,
} from "../../../Routes/Settings/CustomerDisplay/CustomerDisplayTypes";
import type { CustomerDisplayComponentProps, CustomerDisplayTotal } from "../CustomerDisplay";

interface Props extends CustomerDisplayComponentProps<TotalsComponentSettings, CustomerDisplayTotal> {}

export const DEFAULT_TOTAL_COLUMNS: TotalsComponentColumns = {
    total    : { name: "Total:", enabled: true },
    savings  : { name: "Savings:", enabled: true },
    change   : { name: "Change:", enabled: true },
    approved : { name: "Approved", enabled: true },
    thanks   : { name: "Thanks", enabled: true },
    remaining: { name: "Remaining", enabled: false },
    paid     : { name: "Paid", enabled: false },
};

export const CustomerDisplayTotals: FC<Props> = ({ settings, data }) => {
    const style: CSSProperties = {
        backgroundColor: settings.background,
        color          : settings.color,
        fontSize       : settings.fontSize + "pt",
        fontStyle      : settings.italic ? "italic" : "normal",
        fontWeight     : settings.bold ? "bold" : "normal",
        textDecoration : settings.underline ? "underline" : "none",
    };

    return (
        <div className="customer-display-totals w-full h-full" style={style}>
            {settings.order.map(key => {
                const row = settings.rows[key] ?? DEFAULT_TOTAL_COLUMNS[key];

                if(!row.enabled) {
                    return;
                }

                if(!data[key]) {
                    return;
                }

                let text = "";

                if(typeof data[key] !== "boolean") {
                    text = " " + data[key];
                }

                const rowStyle: CSSProperties = {};

                if(key === "savings" || key === "remaining" || key === "paid") {
                    rowStyle.color = settings.promotion;
                    rowStyle.fontSize = (parseFloat(settings.fontSize) / 4 * 3) + "pt";
                    rowStyle.textDecoration = style.textDecoration;
                }

                return (
                    <div key={key} className={key} style={rowStyle}>
                        {row.name + text}
                    </div>
                );
            })}
        </div>
    );
};
